/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ObjectSchemaService extends services.DataService<Wars.Domain.Model.ObjectSchema> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private schemaPropertyService: services.SchemaPropertyService) {
            super(injectedBreeze, $q);
        }

        public getObjectSchema(id: string): ng.IPromise<Wars.Domain.Model.ObjectSchema> {
            return this.fetchById(id, "ObjectSchema");
        }

        public getObjectSchemaExpanded(id: string): angular.IPromise<Wars.Domain.Model.ObjectSchema> {
            var d = this.$q.defer();

            if (!id) {
                d.resolve(null);
                return d.promise;
            }

            var parameters = {
                objectSchemaId: id
            };

            const query = this.breezeModule.EntityQuery
                .from("ObjectSchemaExpanded")
                .withParameters(parameters);

            this.executeQuery(query).then(
                (groups) => d.resolve(groups[0]));

            return d.promise;
        }

        public createNewObjectSchema(): warsApp.models.ObjectSchema {
            var newObjectSchema = this.createNewEntity<warsApp.models.ObjectSchema>("ObjectSchema");
            newObjectSchema.isList = false;
            newObjectSchema.uniqueIdentifier = services.UtilityService.generateGuidComb();
            return newObjectSchema;
        }

        public createNewListObjectSchema(): Wars.Domain.Model.ObjectSchema {
            var newObjectSchema = this.createNewEntity<Wars.Domain.Model.ObjectSchema>("ObjectSchema");
            newObjectSchema.isList = true;
            newObjectSchema.uniqueIdentifier = services.UtilityService.generateGuidComb();
            return newObjectSchema;
        }

        public validateObjectSchema(objectSchema: Wars.Domain.Model.ObjectSchema): string[] {
            var results = [];
            if (objectSchema && objectSchema.properties) {
                objectSchema.properties.forEach(property => {
                    results = results.concat(this.validateSchemaProperty(property));
                });
            }
            return results;
        }

        public cloneObjectSchema(objectSchema: Wars.Domain.Model.ObjectSchema, schemaPropertyId?: string): warsApp.models.ObjectSchema {
            let obj = this.createNewObjectSchema();

            obj.name = objectSchema.name;
            obj.dataSource_id = objectSchema.dataSource_id;
            obj.formUniqueId = objectSchema.formUniqueId;
            obj.isList = objectSchema.isList;
            obj.clonedFromId = objectSchema.id;

            if (schemaPropertyId) {
                obj.schemaProperty_id = schemaPropertyId;
            }

            obj.uniqueIdentifier = services.UtilityService.generateGuidComb();

            objectSchema.properties.forEach(prop => {
                obj.properties.push(this.cloneSchemaProperty(prop));
            });

            return obj;
        }

        public cloneSchemaProperty(property: Wars.Domain.Model.SchemaProperty): warsApp.models.SchemaProperty {
            let prop = this.schemaPropertyService.createNewSchemaProperty();

            prop.propertyType = property.propertyType;
            prop.name = property.name;
            prop.codeGroup_id = property.codeGroup_id;
            prop.isIndexed = property.isIndexed;
            prop.isSystemLevel = property.isSystemLevel;
            prop.scheduledResourceConfiguration_id = property.scheduledResourceConfiguration_id;
            prop.systemVariable_id = property.systemVariable_id;
            prop.type_id = property.type_id;
            prop.uniqueIdentifier = services.UtilityService.generateGuidComb();
            prop.clonedFromId = property.id;

            if (property.typeSchema) {
                prop.typeSchema = this.cloneObjectSchema(property.typeSchema, property.id);
            }

            return prop;
        }

        private validateSchemaProperty(schemaProperty: Wars.Domain.Model.SchemaProperty): string[] {
            var results = [];
            if (UtilityService.isNullOrWhiteSpace(schemaProperty.name)) {
                results.push("The Name field cannot be empty.");
            }
            if (schemaProperty.propertyType === null) {
                results.push("A Variable Type must be selected from the drop down.");
            }
            if (schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Code && schemaProperty.codeGroup === null) {
                results.push("A Code Group must be selected for Code Variable Types. Variable with missing code group: " + schemaProperty.name ? schemaProperty.name : "Un-Named");
            }
            if (schemaProperty.typeSchema) {
                results = results.concat(this.validateObjectSchema(schemaProperty.typeSchema));
            }
            return results;
        }
    }
}

warsApp.registerService("ObjectSchemaService", ["breeze", "$q", "schemaPropertyService"]);